import { toNameConfigMapping } from '../../../configFields';
import { BinaryPoll } from './BinaryPoll';
import { MultiplePoll } from './MultiplePoll';
import { RatingDigitsPoll } from './RatingDigitsPoll';
import { RatingLikePoll } from './RatingLikePoll';
import { RatingSliderPoll } from './RatingSliderPoll';
import { RatingSmiliesPoll } from './RatingSmiliesPoll';
import { RatingStarsPoll } from './RatingStarsPoll';
import { SingleFromPicturePoll } from './SingleFromPicturePoll';
import { SinglePoll } from './SinglePoll';
import { SwitchPoll } from './SwitchPoll';
import { TextareaPoll } from './TextareaPoll';

export const Questions = {
  MultiplePoll,
  RatingDigitsPoll,
  RatingLikePoll,
  RatingSliderPoll,
  RatingSmiliesPoll,
  RatingStarsPoll,
  SingleFromPicturePoll,
  SinglePoll,
  TextareaPoll,
  SwitchPoll,
  BinaryPoll,
};

export const questionsList = [
  MultiplePoll,
  RatingDigitsPoll,
  RatingLikePoll,
  RatingSliderPoll,
  RatingSmiliesPoll,
  RatingStarsPoll,
  SingleFromPicturePoll,
  SinglePoll,
  TextareaPoll,
  SwitchPoll,
  BinaryPoll,
] as const;

export const questionsMapping = toNameConfigMapping(questionsList);
